import {
	fetch,
	setpromise,
    fetchForDoterra,
    fetchForCVO,
    fetchForDoterraWX,
	sconfig,
    fetchForCDN,
} from '@/config/fetch'
const product = require('@/service/mock/product')
if (sconfig.all||(!sconfig.all&&sconfig.order)) {
	
}
else{
    var getNoticeInfo = (token,user_id,v,lut) => fetchForDoterraWX('GET', 'cg020',token,user_id,{v,lut});
    
    var getWarehouseInfo = (token, user_id, v, lut) => fetchForDoterraWX('GET', 'og000', token, user_id, {
        v,
        lut
    });
    var getProductStock = (token, user_id, s, v, lut) => fetchForDoterraWX('GET', 'pg002', token, user_id, {
        v,
        lut,
        s
    });

    var getProductInfo = (token, user_id, fc, v, lut) => fetchForDoterraWX('GET', 'pg001', token, user_id, {
        v,
        lut,
        fc
    });
    var getCDNProductInfo = (token, user_id, params) => fetchForCDN('GET', 'pg001', token, user_id,params);

     var getProductDetail=(token,user_id,sku)=>fetchForCDN('GET','pg004',token,user_id,{sku},fetchForDoterraWX);
    //var getProductDetail=(token,user_id,sku)=>setpromise(product.Detail);

    var getProductDetail1=(token,user_id,sku,it)=>fetchForCDN('GET','pg006',token,user_id,{sku},()=>fetchForDoterraWX('GET','pg006',token,user_id,{sku,it}));

    var getArticleDetail = (token,uid,params) => fetchForDoterraWX('GET','cgad001',token,uid,params)
    var getTipDetail = (token,uid,params) => fetchForCDN('GET','cgad001',token,uid,params)

    var getProductLimt=(token,user_id,fc)=>fetchForDoterraWX('GET', 'pg005',token,user_id,{fc});

    var saveCart = (token, user_id, cart, v, lut) => fetchForDoterraWX('POST', 'oc002', token, user_id, {
        v,
        lut,
        cart
    });
    var clearCart = (token, user_id, customerid) => fetchForDoterraWX('GET', 'oc004', token, user_id, {
        customerid
    });
    var saveWarehouse = (token,user_id,warehouse) => fetchForDoterraWX('POST', 'oc003',token,user_id,{warehouse});

    var getCustomerNumStatistics=(token,user_id,y)=>fetchForDoterraWX('GET', 'mg017',token,user_id,{y});

    var GetUserAccountAR = (token,user_id,vipNo,cv) => fetchForDoterraWX('GET', 'oc011',token,user_id,{vipNo,cv});

    var getUserAccountPoint =  (token,user_id,vipNo,cv) => fetchForDoterraWX('GET', 'oc010',token,user_id,{vipNo,cv});

     //编辑地址
     var postAddAddress = (token, uid, address) => fetchForDoterraWX('POST', 'ms001', token, uid, {
        address
    });
    //删除地址
    var delAddress = (token, uid, userId = '', id) => fetchForDoterraWX('GET', 'md003', token, uid, {
        userId,
        id
    })
    var CheckInventory = (token,user_id,shipMethod,orderNo,products) => fetchForDoterraWX('POST', 'oc020',token,user_id,{shipMethod,orderNo,products});

    var getProductOrder = (token, user_id, orderno, customerid, y,original) => fetchForDoterraWX('GET', 'oc005', token, user_id, {
        orderno,
        customerid,
        y,
        original
    });

    var saveOrder = (token, user_id, cart, v, lut) => fetchForDoterraWX('POST', 'og010', token, user_id, {
        v,
        lut,
        cart
    });
    var payOrder = (token, user_id, orderNo,pc,original) => fetchForDoterraWX('GET', 'og011', token, user_id, {
        'on': orderNo,
        pc,
        original
    });
    var getOrderStatus=(token,user_id,order_no)=>fetchForDoterraWX('GET', 'og014', token, user_id, {order_no});

    var unionPay = (token,user_id,params) => fetchForDoterraWX('GET', 'llzf001', token, user_id, params);

    var getProductRelated = (token,user_id,sku) => fetchForCDN('GET', 'pg007',token,user_id,{
        sku
    },fetchForDoterraWX);

    var WxcheckCode = (token, user_id, type, code, uc) => fetchForDoterraWX('GET', 'mc001', token, user_id, {
		vv: code,
		vt: type,
		uc,
    });

    var getPromote = (token,user_id,vipno) => fetchForDoterraWX('GET', 'og020',token,user_id,{vipno});

    var checkBirthdaySuit=(token,user_id,uid) =>fetchForDoterraWX('GET','mc001',token,user_id,{
        vt:'birthdaysuit',
        vv:uid
    });

    var changeOrderAddress=(token,user_id,address)=>fetchForDoterraWX('POST', 'odau001',token,user_id,{address});

    var checkCharitableOrder=(token,uid,orderNo)=>fetchForDoterraWX('GET','mc001',token,uid,{
		vt:'checkcharitableorder',
		uc:orderNo,
		vv:1
    })

    var checkQuestionnaire = (token,VipNo) => fetchForCVO('GET','QS_01',token,VipNo);

    var checkPromoCode=(token,user_id,vipno,code,sku) =>fetchForDoterraWX('GET','mc001',token,user_id,{
        vt:'checpromocode',
        uc:vipno,
        icpwd:code,
        vv:sku
    });

    var getCartInfo = (token, user_id, fc) => fetchForDoterraWX('GET', 'oc001', token, user_id, {
        fc,
    });

    var updateCart = (token, user_id, s,q,i,c,r,pf) => fetchForDoterraWX('GET', 'oc008', token, user_id, {
        s,
        q,
        i,
        c,
        r,
        pf
    });
    var postSpecInfo = (token, user_id, params) => fetchForDoterraWX('POST', 'csi001', token, user_id, {
        ...params
    });
    var getSpecInfo = (token, user_id, res,pcode,category,customerId) => fetchForDoterraWX('GET', 'csi002', token, user_id,{
        res,
        pcode,
        category,
        customerId
    });
    var getOrderEncryption=(token,user_id,order_no)=>fetchForDoterraWX('GET','og005',token, user_id,{order_no});
    var getOrders = (token, vipNo, params) => fetchForCVO('GET', 'OD_01', token, vipNo, params);
    var getWXOrderList = (token, uid, params) => fetchForDoterraWX('GET', 'og001', token, uid, params);
    //获取订单详细
    var getWXOrderDetail = (token, uid, userid, id) => fetchForDoterraWX('GET', 'og002', token, uid, {
        userid,
        id
    });
    var getOMSOrderDetail = (token, vipNo, OrderNo) => fetchForCVO('GET', 'OD_02', token, vipNo, {
        OrderNo
    });
    var getOrderChannel = (token, vipNo, OrderId) => fetchForCVO('GET', 'OD_04', token, vipNo, {
        OrderId
    });
    var cancelHistoryOrder = (token,user_id,OrderId)=>fetchForDoterraWX('POST','OC007',token,user_id,{OrderId});
    var getOrderInvoice=(token, vipno, orderno) => fetchForCVO('GET','invoice004',token,vipno,{OrderNo:orderno})
    var getInvoiceInfo=(token, vipno) => fetchForCVO('GET','invoice005',token,vipno);
    var postOrderInovice=(token, vipno, OrderNo,OriginalID,OrderDate,InvoiceAmount,invoice) => fetchForCVO('POST','invoice003',token,vipno, {
		OrderNo:OrderNo,
		OriginalID:OriginalID,
		OrderDate:OrderDate,
		InvoiceAmount:InvoiceAmount,
		TaxPayerId:invoice.TaxPayerId,
		InvoiceTitle:invoice.InvoiceTitle,
		CompanyType:invoice.CompanyType,
		Address:invoice.Address,
		Phone:invoice.Phone,
		BankName:invoice.BankName,
		BankNo:invoice.BankNo,
		Email:invoice.Email,
		vipNo:vipno
    });
    var postInvoiceInfo=(token, vipno, invoice) => fetchForCVO('POST','invoice002',token,vipno,{
		TaxPayerId:invoice.TaxPayerId,
		InvoiceTitle:invoice.InvoiceTitle,
		CompanyType:invoice.CompanyType,
		Address:invoice.Address,
		Phone:invoice.Phone,
		BankName:invoice.BankName,
		BankNo:invoice.BankNo,
		Email:invoice.Email,
		vipNo:vipno,
		ID:invoice.ID
    });
    var postDeleteInvoiceInfo=(token, vipno, ID) => fetchForCVO('POST','invoice006',token,vipno, {
		ID:ID,
    });
    var GetInvoiceDown=(token,vipno,orderno) => fetchForCVO('GET','invoice007',token,vipno,{orderno});
    var GetInvoiceCancel=(token,vipno,RecordId) => fetchForCVO('POST','invoice008',token,vipno,{RecordId});
    var postInvoiceEmail = (token,user_id,RecordId,EmailAddress) => fetchForCVO('POST','invoice009',token,user_id,{RecordId,EmailAddress});
    var getInvoiceEmail = (token,user_id) => fetchForCVO('GET','invoice010',token,user_id,{});
    var CancelOrder = (token, user_id, orderno) => fetchForDoterraWX('GET', 'oc006', token, user_id, {
        orderno
    });

    var getAccountBalance=(token,user_id)=>fetchForDoterraWX('GET', 'mgab001', token, user_id)

    var checkAccountBalance=(token,user_id,params)=>fetchForDoterraWX('POST', 'mcab001', token, user_id,params)
    var mergeOrders = (token,userid,VipNo,Address,OrderList) => fetchForDoterraWX('POST', 'ODG001', token, userid,{VipNo,Address,OrderList})
    var getMergeOrders = (token,userid,VipNo,OcNo) => fetchForDoterraWX('POST', 'ODG002', token, userid,{VipNo,OcNo})
    var getPaidMergeOrders = (token,userid,VipNo,OCNo) => fetchForDoterraWX('POST', 'ODG003', token, userid,{VipNo,OCNo})
    var mergePaidOrders = (token,userid,VipNo,Address,OCNo) => fetchForDoterraWX('POST', 'ODG004', token, userid,{VipNo,OCNo,Address})

    var getCustomerRewards=(token,uid,orderNo,vipNo)=>fetchForDoterraWX('GET','mg018',token,uid,{orderNo,vipNo})
    var lrptSaveCustomerDate=(token,uid, info)=>fetchForDoterraWX('POST','lrp007',token,uid,{info});
    var getCustomerCoupons = (token,uid) => fetchForDoterraWX('GET','mgcc001',token,uid);

    var getRightTopNum = (token,uid) => fetchForDoterraWX('GET', 'mgcon001', token, uid);
    var getProductMenuTree = (token,uid) => fetchForCDN('GET','pg008',token,uid,{list:'list'});

    var getVideoService = (token,uid,Code,sign) => fetchForDoterraWX('POST', 'tj001', token, uid,{Code, sign})
    var getMergePayOrder = (token,uid,mergeOrderNo)=> fetchForDoterraWX('GET', 'mog011', token, uid,{mergeOrderNo,payChannel:''})
    var getMergePayOrderCount = (token,uid)=> fetchForDoterraWX('GET', 'mog012', token, uid)
    var checkHighLevelFirstProduct = (token,uid,orderNo) => fetchForDoterraWX('GET', 'fpd001', token, uid,{orderNo})
    var getBOGOConfig = (token,uid)=>fetchForCDN('GET','gbogo001',token,uid,{index:'index'},undefined,true)
    
    // 获取加购活动配置
    var getPurchaseEvent = (params)=>fetch('POST','/api/doevent/event/myevents','','',params,'Newframework')
    // 获取加购产品信息
    var getPurchaseProducts = (token,uid,sku)=>fetchForDoterraWX('GET', 'pg009', token, uid,{sku})

    // 获取库存紧张阈值
    var getStockThreshold = (token,uid)=>fetchForDoterraWX('GET', 'pg010', token, uid)
}
export {
    getNoticeInfo,
    getWarehouseInfo,
    getProductStock,
    getProductInfo,
    getProductDetail,
    getProductDetail1,
    getArticleDetail,
    getProductLimt,
    getCustomerNumStatistics,
    GetUserAccountAR,
    getUserAccountPoint,
    
    CheckInventory,
    clearCart,
    saveCart,
    saveWarehouse,
    postAddAddress,
    delAddress,
    getProductOrder,
    saveOrder,
    payOrder,
    getOrderStatus,
    unionPay,
    getProductRelated,
    WxcheckCode,
    getPromote,
    checkBirthdaySuit,
    changeOrderAddress,
    checkCharitableOrder,
    checkQuestionnaire,
    checkPromoCode,
    getCartInfo,
    updateCart,
    postSpecInfo,
    getOrderEncryption,
    getWXOrderList,
    getOrders,
    getWXOrderDetail,
    getOMSOrderDetail,
    getOrderChannel,
    cancelHistoryOrder,

    getOrderInvoice,
    getInvoiceInfo,
    postOrderInovice,
    postInvoiceInfo,
    postDeleteInvoiceInfo,
    GetInvoiceDown,
    GetInvoiceCancel,
    postInvoiceEmail,
    getInvoiceEmail,
    CancelOrder,
    getAccountBalance,
    checkAccountBalance,
    getSpecInfo,
    mergeOrders,
    getMergeOrders,
    getPaidMergeOrders,
    mergePaidOrders,
    getTipDetail,
    getCDNProductInfo,

    getCustomerRewards,
    lrptSaveCustomerDate,
    getCustomerCoupons,
    getRightTopNum,
    getProductMenuTree,

    getVideoService,
    getMergePayOrder,
    getMergePayOrderCount,
    checkHighLevelFirstProduct,
    getBOGOConfig,
    getPurchaseEvent,
    getPurchaseProducts,
    getStockThreshold,
}
